require('./adjustmentForm.scss')

module.exports = {
  template: require('./adjustmentForm.pug')()
  controller: require('./adjustmentForm.ctrl')
  bindings:
    salonId: '<'
    onSubmit: '&'
}
